import React from 'react';

const DashboardFormulaCard = ({
  focusTags,
  hasLastQuiz,
  showOmegaUpsell,
  onRetake,
  onViewIngredients,
  onExploreOmega3,
  onEditFormula,
  formulaEdit,
  t,
}) => {
  const visibleTags = focusTags?.length ? focusTags : [t('Dashboard_Formula_DefaultTag')];

  return (
    <section className="t-rounded-[14px] t-border t-border-g200 t-bg-white t-p-6">
      <p className="t-m-0 t-text-lg t-font-extrabold t-text-navy">{t('Dashboard_Formula_Title')}</p>
      <p className="t-m-0 t-mt-1 t-text-sm t-text-teal-muted">
        {t('Dashboard_Formula_Subtitle')}
      </p>
      <div className="t-mt-5 t-flex t-flex-wrap t-gap-3">
        {visibleTags.map((tag) => (
          <span
            className="t-rounded-full t-bg-teal-bg t-px-4 t-py-2 t-text-sm t-font-extrabold t-text-quiz-teal"
            key={`formula-tag-${tag}`}
          >
            {tag}
          </span>
        ))}
      </div>
      <p className="t-m-0 t-mt-5 t-text-sm t-text-teal-muted">
        {t('Dashboard_Formula_Body')}
      </p>
      <div className="t-mt-4 t-flex t-flex-wrap t-gap-5">
        {hasLastQuiz && (
          <button
            type="button"
            className="t-border-0 t-border-b-2 t-border-solid t-border-quiz-teal t-bg-transparent t-p-0 t-text-sm t-font-extrabold t-text-quiz-teal"
            onClick={onRetake}
          >
            {t('Dashboard_Formula_Retake')}
          </button>
        )}
        <button
          type="button"
          className="t-border-0 t-border-b-2 t-border-solid t-border-teal-muted t-bg-transparent t-p-0 t-text-sm t-font-extrabold t-text-teal-muted"
          onClick={onViewIngredients}
        >
          {t('Dashboard_Formula_ViewIngredients')}
        </button>
        {formulaEdit?.canEdit && (
          <button
            type="button"
            className="t-border-0 t-border-b-2 t-border-solid t-border-quiz-teal t-bg-transparent t-p-0 t-text-sm t-font-extrabold t-text-quiz-teal"
            onClick={onEditFormula}
          >
            {t('DashboardFormula_Edit')}
          </button>
        )}
      </div>
      {formulaEdit?.pendingChange && (
        <p role="status" className="t-mt-3 t-text-sm t-text-teal-muted">
          {t(formulaEdit.pendingChange.type === 'formula' ? 'DashboardFormula_Pending' : 'DashboardFormula_PlanPending', {
            date: new Date(formulaEdit.pendingChange.effectiveAt).toLocaleDateString(),
          })}
        </p>
      )}
      {formulaEdit?.hasAttachedSchedule && !formulaEdit?.pendingChange && (
        <p role="status" className="t-mt-3 t-text-sm t-text-teal-muted">
          {t('DashboardFormula_ScheduleCompleting')}
        </p>
      )}

      {showOmegaUpsell && (
        <div className="t-mt-5 t-flex t-flex-col t-gap-4 t-rounded-[14px] t-border t-border-g200 t-bg-white t-px-5 t-py-4 md:t-flex-row md:t-items-center md:t-justify-between">
          <div>
            <p className="t-m-0 t-font-serif t-text-lg t-leading-tight t-text-navy">
              {t('Dashboard_Omega_Title')}
            </p>
            <p className="t-m-0 t-mt-1 t-text-sm t-text-teal-muted">
              {t('Dashboard_Omega_Body')}
            </p>
          </div>
          <button
            type="button"
            className="t-w-full t-rounded-full t-border-0 t-bg-butter t-px-6 t-py-3 t-text-sm t-font-extrabold t-text-navy md:t-w-auto md:t-whitespace-nowrap"
            onClick={onExploreOmega3}
          >
            {t('Dashboard_Omega_Cta')}
          </button>
        </div>
      )}
    </section>
  );
};

export default DashboardFormulaCard;
